import React, { useRef, useState } from "react";
import { api } from "@/lib/api";
import { Card, Btn } from "@/components/UI";
import { Upload, Star, ArrowLeft, ArrowRight, X } from "lucide-react";
import { AuthImage } from "@/components/products/AuthImage";
import { apiError } from "@/lib/customers";

export function ProductImages({ product, onChange, canEdit }) {
  const input = useRef(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const photos = [...(product.photos || [])].sort((a, b) => a.order - b.order);
  const base = `/products/${product.id}/photos`;
  const run = async (fn) => {
    setErr("");
    try { await fn(); onChange(); } catch (e) { setErr(apiError(e, "İşlem başarısız")); }
  };
  const upload = async (files) => {
    setBusy(true);
    for (const file of files) {
      const fd = new FormData();
      fd.append("file", file);
      await run(() => api.postForm(base, fd));
    }
    setBusy(false);
    if (input.current) input.current.value = "";
  };
  const move = (i, dir) => {
    const ids = photos.map((p) => p.id);
    [ids[i], ids[i + dir]] = [ids[i + dir], ids[i]];
    run(() => api.put(`${base}/order`, { order: ids }));
  };

  return (
    <Card className="p-5" data-testid="product-images">
      <div className="flex items-center justify-between mb-3">
        <div className="text-sm font-semibold text-slate-700">Görseller</div>
        {canEdit && <Btn size="sm" variant="secondary" disabled={busy} onClick={() => input.current?.click()} data-testid="prod-image-upload-btn"><Upload size={12} /> {busy ? "Yükleniyor…" : "Görsel Yükle"}</Btn>}
        <input ref={input} type="file" accept="image/*" multiple hidden onChange={(e) => upload([...e.target.files])} data-testid="prod-image-input" />
      </div>
      {err && <div className="mb-3 text-xs text-rose-700 bg-rose-50 border border-rose-200 rounded-md px-3 py-2" data-testid="prod-image-error">{err}</div>}
      {!photos.length && <div className="text-xs text-slate-500" data-testid="prod-image-empty">Henüz görsel yok. İlk yüklenen görsel ana görsel olur.</div>}
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
        {photos.map((p, i) => (
          <div key={p.id} className={`relative rounded-lg overflow-hidden border-2 ${p.is_primary ? "border-amber-400" : "border-transparent"}`} data-testid={`prod-image-${p.id}`}>
            <AuthImage path={`${base}/${p.id}?variant=thumb`} className="w-full aspect-square" />
            {p.is_primary && <span className="absolute top-1 left-1 text-[10px] px-1.5 py-0.5 rounded bg-amber-400 text-white font-semibold">ANA</span>}
            {canEdit && <div className="absolute bottom-0 inset-x-0 flex justify-between bg-black/50 p-1">
              <button disabled={i === 0} onClick={() => move(i, -1)} className="text-white disabled:opacity-30" data-testid={`prod-image-left-${p.id}`}><ArrowLeft size={14} /></button>
              <button onClick={() => run(() => api.put(`${base}/${p.id}/primary`))} className="text-white" title="Ana görsel yap" data-testid={`prod-image-primary-${p.id}`}><Star size={14} /></button>
              <button onClick={() => window.confirm("Görsel kaldırılsın mı?") && run(() => api.del(`${base}/${p.id}`))} className="text-white" data-testid={`prod-image-delete-${p.id}`}><X size={14} /></button>
              <button disabled={i === photos.length - 1} onClick={() => move(i, 1)} className="text-white disabled:opacity-30" data-testid={`prod-image-right-${p.id}`}><ArrowRight size={14} /></button>
            </div>}
          </div>
        ))}
      </div>
    </Card>
  );
}
